import React, { useContext, useState } from 'react';
import { Container, ContainerGrid } from './style';
import { BuscaParceiro, BuscaProduto } from '~/components/NovosInputs';
import { useForm } from 'react-hook-form';
import { LojaContext } from '~/context/loja';
import { GroupButtons } from './components/GroupButtons/GroupButtons';
import { DataGrid, GridColDef } from '@material-ui/data-grid';
import api from '~/services/api';
import { nanoid } from 'nanoid';
import { format } from 'date-fns';
import { createDateWithoutTimezone } from '~/utils/createDateWithoutTimezone ';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import { FaPrint } from 'react-icons/fa';
import PDFGenerator from './classes/PDFGenerator';
import { toast } from 'react-toastify';
import FormDefault from '~/components/FormDefault';
import { Col, Row } from 'react-bootstrap';
import Tippy from '@tippyjs/react';

const HabitoDeConsumo: React.FC = () => {
  const { loja } = useContext(LojaContext);
  const [periodo, setPeriodo] = useState({
    value: 1,
    label: 'Hoje',
  });
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [produtosNoPeriodo, setProdutosNoPeriodo] = useState<any[]>([]);

  const {
    handleSubmit,
    register,
    control,
    clearErrors,
    reset,
    formState: { errors },
    setValue,
  } = useForm();

  const getHabitos = handleSubmit(async (data) => {
    setIsFetching(true);
    const apiPayload = {
      cod_cliente: data?.cod_pessoa?.value,
      cod_produto: data?.produtos?.value,
      periodo: periodo.value,
    };
    try {
      const apiData = await api.get('/busca-habitos-de-consumo', {
        params: {
          ...apiPayload,
        },
      });
      if (apiData.data.data.length > 0) {
        const formatterItens = apiData.data.data.map((item: any) => {
          const uuid = nanoid();
          const dataUltimaVenda = format(
            createDateWithoutTimezone(item.dta_ult_venda),
            'dd/MM/yyyy',
          );

          const dataProxVenda = format(
            createDateWithoutTimezone(item.dta_prox_venda),
            'dd/MM/yyyy',
          );
          return {
            id: uuid,
            uuid,
            dataProxVenda,
            dataUltimaVenda,
            ...item,
          };
        });
        setProdutosNoPeriodo(formatterItens);
        return;
      }
      setIsFetching(false);
      return toast.warn(
        'Nenhum registro encontrado conforme os critérios informados.',
      );
    } catch (error) {
      setIsFetching(false);
    }
  });

  const clearForm = () => {
    setPeriodo({
      value: 1,
      label: 'Hoje',
    });
    reset();
    setProdutosNoPeriodo([]);
    setIsFetching(false);
  };

  const cancelSearch = () => {
    setProdutosNoPeriodo([]);
    setIsFetching(false);
  };

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 90, hide: true },
    {
      field: 'cod_produto',
      headerName: 'PLU',
      width: 130,
      editable: false,
    },
    {
      field: 'des_produto',
      headerName: 'Produto',
      width: 280,
      editable: false,
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <Tippy content={row.des_produto} arrow animation="scale">
            <div className="text-truncate" style={{ width: '280px' }}>
              <span>{row.des_produto}</span>
            </div>
          </Tippy>
        );
      },
    },
    {
      field: 'des_cliente',
      headerName: 'Cliente',
      width: 350,
      editable: false,
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <Tippy content={row.des_cliente} arrow animation="scale">
            <div className="text-truncate" style={{ width: '350px' }}>
              <span>{row.des_cliente}</span>
            </div>
          </Tippy>
        );
      },
    },
    {
      field: 'qtd_vendida',
      headerName: 'Qtd',
      width: 100,
      editable: false,
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <>
            <span>{row.qtd_vendida?.toString()?.replace('.', ',')}</span>
          </>
        );
      },
    },
    {
      field: 'dataUltimaVenda',
      headerName: 'Dta. Últ. Vda',
      width: 160,
      editable: false,
    },
    {
      field: 'qtd_dias_media',
      headerName: 'Qtd. Dias Média',
      width: 160,
      editable: false,
    },
    {
      field: 'dataProxVenda',
      headerName: 'Dta Próx. Vda',
      width: 160,
      editable: false,
    },
    {
      field: '',
      headerName: 'Ação',
      width: 98,
      editable: false,
    },
  ];

  const handlePrint = () => {
    if (produtosNoPeriodo.length > 0 && loja) {
      const pdfGenerator = new PDFGenerator(produtosNoPeriodo, loja);
      pdfGenerator.generatePDF();
    }
  };

  return (
    <Container>
      <FormDefault
        codTela={321}
        title="Análise de Hábito de Consumo"
        onSave={() => Promise.resolve()}
        onCancel={() => []}
        onClearFields={() => []}
        onNew={() => []}
        onDelete={() => []}
        onReturnSearch={() => []}
        isDelete={false}
        isNew={false}
        isCancel={false}
        isClear={false}
        isSave
        customButtons={
          <CustomButtonNovo
            variant="default"
            disabled={produtosNoPeriodo.length <= 0}
            onClick={handlePrint}
            style={{ backgroundColor: '#666666' }}
            label="Imprimir"
            icon={FaPrint}
          />
        }
      >
        <Row>
          <Col md={6} sm={12}>
            <BuscaProduto
              id="produtos"
              label="Produto"
              placeholder="Selecione..."
              name="produtos"
              register={register}
              isError={!!errors.produtos}
              disabled={isFetching}
              control={control}
              buscaNasLojas={[Number(loja.cod_loja)]}
              customOptions={{
                hideBuscarPor: true,
                buscarPor: ['Produto'],
                showSelecionarItensContendo: false,
                consumoMonitorado: true,
              }}
              getProduct={(selected: any) => {
                [];
              }}
              style={{ width: '100%', height: '41px' }}
              setValue={setValue}
            />
          </Col>
          <Col md={6} sm={12}>
            <BuscaParceiro
              label="Cliente"
              placeholder="Selecione..."
              name="cod_pessoa"
              disabled={isFetching}
              register={register}
              isError={!!errors.cod_pessoa}
              control={control}
              customOptions={{
                buscarPor: { cliente: true, fornecedor: false, loja: false },
              }}
              changeSelected={(selected: any) => {
                clearErrors('cod_pessoa');
                const cod = selected.num_cpf_cnpj ? selected.num_cpf_cnpj : '';
                const nome = selected.nome_pessoa ? selected.nome_pessoa : '';
                setValue('cod_pessoa', {
                  value: selected.value,
                  label: `${cod} - ${nome}`,
                });
              }}
            />
          </Col>
        </Row>
        <GroupButtons
          tipoPeriodo={periodo}
          setTipoPeriodo={setPeriodo}
          cancelSearch={cancelSearch}
          isFetching={isFetching}
          getTitulosAPagar={getHabitos}
          clearForm={clearForm}
        />

        <ContainerGrid>
          <DataGrid
            className="DataGrid"
            style={{ height: '325px' }}
            rows={produtosNoPeriodo}
            columns={columns}
            disableSelectionOnClick
            hideFooterSelectedRowCount
            hideFooterPagination
            hideFooterRowCount
            hideFooter
            autoHeight
            disableColumnMenu
            localeText={{
              noRowsLabel: 'Nenhum registro encontrado...',
              columnMenuLabel: 'Menu',
              columnMenuFilter: 'Filtrar',
              columnMenuHideColumn: 'Esconder',
              columnMenuUnsort: 'Não ordenar',
              columnMenuSortAsc: 'Ordernar ASC',
              columnMenuSortDesc: 'Ordernar DESC',
              columnMenuShowColumns: 'Mostrar colunas',
            }}
          />
        </ContainerGrid>
      </FormDefault>
    </Container>
  );
};

export default HabitoDeConsumo;
